
















import { Component, Prop, Vue } from "vue-property-decorator";
import Card from "@/components/card.vue";
import {
  CardSetName,
  ALL_CARD_SETS,
  getCardSetByName
} from "../store/card-sets";

@Component({
  components: { Card }
})
export default class CardsView extends Vue {
  @Prop() cardSetName!: CardSetName;
  @Prop() cardValue!: string;

  goToCard(specificCardValue: string) {
    this.$router.push({
      path: "/card/" + encodeURIComponent(specificCardValue)
    });
    document.documentElement.requestFullscreen();
  }

  get cardArray(): string[] {
    return getCardSetByName(this.cardSetName).cardArray;
  }
}
